// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3S1gN","bigColWidth":"Table_bigColWidth__2PByI","biggerColWidth":"Table_biggerColWidth__3QymM","row":"Table_row__1Ts1i","col":"Table_col__b_tz9"};